import axios from '@/axios.js'
import ln from '../../http/requests/loans/index.js'
import hr from '../../http/requests/hrms/index.js'
import photoUpload from '../../http/requests/photo/index.js'
export default {
  addLoans({ commit }, item) {
    return new Promise((resolve, reject) => {
        axios.post('/api/loan', item)
          .then((response) => {
            commit('ADD_LOANS', response.data.data)//Object.assign(item, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  updateLoans({ commit }, item) {
    return new Promise((resolve, reject) => {
        axios.put('/api/loan', item)
          .then((response) => {            
            //console.log(response.data.data)
            commit('UPDATE_LOANS', response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  getAllEmployeeLoans({commit}, payload) {
    return new Promise((resolve, reject) => {
        ln.getAllLoans(payload.sortBy, payload.sortOrder, payload.pageNumber, payload.pageSize, payload.isApprover)
          .then((response) => {
            commit('GET_ALL_LOANS',  response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },

getAllApproversByModule({commit}, item){
    return new Promise((resolve, reject) => {
      hr.getAllApproversByModule(item.module, item.userId)
        .then((response) => {
          commit('GET_ALL_APPROVERS',  response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  unSubmit({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isDraft: items.isDraft,
        isSubmitted: items.isSubmitted,
        reviewerId: items.reviewerId
      })
        .then((response) => {
          commit('UNSUBMIT_LOANS', items.employeeFiledLoansId)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onCancelled({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isDraft: items.isDraft,
        isSubmitted: items.isSubmitted,
        isCancelled: items.isCancelled,
        cancelledOn: items.cancelledOn,
        isReviewerRevised: items.isReviewerRevised, 
        isApproverRevised: items.isApproverRevised, 
        remarks: items.remarks,
        reviewerId: items.reviewerId
      })
        .then((response) => {
          commit('CANCELLED_LOANS', items)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onRetracked({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isDraft: items.isDraft,
        isRetracted: items.isRetracted,
        retractedOn: items.retractedOn,
        isReviewerApproved: items.isReviewerApproved,
        isApproverApproved: items.isApproverApproved,
        remarks: items.remarks,
        reviewerId: items.reviewerId
      })
        .then((response) => {
          commit('RETRACKED_LOANS', items)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onReviewed({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isReviewerUnread : items.isReviewerUnread, 
        isReviewerApproved: items.isReviewerApproved, 
        reviewerApprovedOn : items.reviewerApprovedOn, 
        isRetracted : items.isRetracted, 
        reviewerId: items.reviewerId
      })
        .then((response) => {
          commit('REVIEWED_LOANS', items)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onReviewerDenied({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isReviewerUnread : items.isReviewerUnread, 
        isReviewerDenied: items.isReviewerDenied, 
        reviewerDeniedOn : items.reviewerDeniedOn, 
        isRetracted : items.isRetracted, 
        reviewerComments: items.reviewerComments,
        reviewerId: items.reviewerId
      })
        .then((response) => {
          commit('REVIEWERDENIED_LOANS', items)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onReviewerRevised({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isReviewerUnread : items.isReviewerUnread, 
        isReviewerRevised: items.isReviewerRevised, 
        reviewerForRevisionOn : items.reviewerForRevisionOn, 
        isRetracted : items.isRetracted, 
        reviewerComments: items.reviewerComments,
        reviewerId: items.reviewerId
      })
        .then((response) => {
          commit('REVIEWERREVISED_LOANS', items)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onApproved({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isApproverUnread : items.isApproverUnread, 
        isApproverApproved: items.isApproverApproved, 
        approverApprovedOn : items.approverApprovedOn, 
        isApproverRetracked : items.isApproverRetracked, 
        approverId: items.approverId
      })
        .then((response) => {
          commit('APPROVED_LOANS', items)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onApproverDenied({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isApproverUnread : items.isApproverUnread,  
        isApproverDenied: items.isApproverDenied, 
        approverDeniedOn : items.approverDeniedOn, 
        isApproverRetracked : items.isApproverRetracked, 
        approverComments: items.approverComments,
        approverId: items.approverId
      })
        .then((response) => {
          commit('APPROVERDENIED_LOANS', items)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onApproverRevised({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/loan/${items.employeeFiledLoansId}`, {
        action: items.action,
        isApproverUnread : items.isApproverUnread, 
        isApproverRevised: items.isApproverRevised, 
        approverForRevisionOn : items.approverForRevisionOn, 
        isApproverRetracked : items.isApproverRetracked, 
        approverComments: items.approverComments,
        approverId: items.approverId
      })
        .then((response) => {
          commit('APPROVERREVISED_LOANS', items)//Object.assign(items, {employeeFiledLoansId: response.data.data.employeeFiledLoansId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
}